export var PdfViewerToolbarAction;
(function (PdfViewerToolbarAction) {
    PdfViewerToolbarAction["ToggleThumbnails"] = "[showpad-pdf-viewer-toolbar-action] Toggle Thumbnails";
    PdfViewerToolbarAction["ZoomIn"] = "[showpad-pdf-viewer-toolbar-action] Zoom In";
    PdfViewerToolbarAction["ZoomOut"] = "[showpad-pdf-viewer-toolbar-action] Zoom Out";
    PdfViewerToolbarAction["SwitchLayout"] = "[showpad-pdf-viewer-toolbar-action] Switch Layout";
})(PdfViewerToolbarAction || (PdfViewerToolbarAction = {}));
export const availablePdfViewerToolbarActions = [
    PdfViewerToolbarAction.ToggleThumbnails,
    PdfViewerToolbarAction.ZoomIn,
    PdfViewerToolbarAction.ZoomOut,
    PdfViewerToolbarAction.SwitchLayout
];
export class PdfViewerToolbarConfig {
    constructor() {
        this.actions = availablePdfViewerToolbarActions;
    }
}
//# sourceMappingURL=pdf-viewer-toolbar-config.type.js.map